import { COLORS } from '../constants/theme';
import { formatProtectionCountdown } from '../utils/protection';

interface ProtectedBadgeProps {
  protectionExpiresAtTick: number | undefined;
  currentTick: number;
}

/**
 * SF-105: shared badge chip for card/row surfaces (Target Finder, War Room, Dossier) showing a
 * province is still within its newbie protection window. Renders nothing when not protected.
 *
 * Not for native `<select>` option lists - those use a text suffix + disabled option instead
 * (see TargetSelector/Thievery/Magic), since a styled component can't live inside `<option>`.
 */
export function ProtectedBadge({ protectionExpiresAtTick, currentTick }: ProtectedBadgeProps) {
  const countdown = formatProtectionCountdown(protectionExpiresAtTick, currentTick);
  if (!countdown) return null;

  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{
        backgroundColor: 'rgba(106, 158, 142, 0.12)',
        color: COLORS.link,
        border: `1px solid rgba(106, 158, 142, 0.3)`,
      }}
      title={countdown}
    >
      {countdown}
    </span>
  );
}
